<template>
  <div>
    <div class="top-controls">
      <b-input-group class="filter-group">
        <b-input-group-prepend is-text>
          <font-awesome-icon icon="search" />
        </b-input-group-prepend>
        <b-form-input :value="filter" placeholder="Type to Search" class="filter-input" @input="$emit('update:filter', $event)"></b-form-input>
        <b-input-group-append>
          <b-button @click="filter = null">Clear</b-button>
        </b-input-group-append>
        <slot name="buttons"></slot>
      </b-input-group>
      <slot name="file-input"></slot>  
    </div>
    
    <slot name="content"></slot>

    <b-pagination :total-rows="totalRows" :value="currentPage" @input="$emit('update:currentPage', $event)" :per-page="perPage" align="right" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      //filter: null
    };
  },

  watch: {
    // currentPage: function() {
    //   this.$emit("update:current-page", this.currentPage);
    // },
    // filter: function() {
    //   this.$emit("update:filter", this.filter);
    // }
  },

  props: {
    items: {
      type: Array,
      required: true
    },

    perPage: {
      type: Number,
      required: false,
      default: 20
    },

    totalRows: {
      type: Number,
      required: false,
      default: 0
    },

    filter: {
      type: String,
      required: false,
      default: null
    },

    currentPage: {
      type: Number,
      required: false,
      default: 1
    }
  }
};
</script>

<style scoped>
.widget-body,
select {
  font-size: 13px;
}

.filter-group {
  margin: 10px 0 15px 0;
  max-width: 600px;
  display: inline-flex;
}

.top-controls {
  margin-bottom: 10px;
}

.align-right {
  text-align: right;
}

.file-input-div {
  display: inline-block;
  margin-bottom: 10px;
}

.upload-button {
  float: right;
  margin-top: 10px;
}
</style>
